import { db } from "@/main";
import {
  LicenceInfoOfClient,
  LicenceVersion,
} from "../models/LicenceInfoOfClient";
import { LicenceInfoV3 } from "../models/LicenceInfoV3";
import { getClientId } from "./ClientRepository";

function getLicenceInfoForClientRef(clientId?: string) {
  return db.collection("licences").doc(clientId ?? getClientId());
}

export function observeLicenceInfoForClient(
  callback: (cicenceInfoOfClient: LicenceInfoOfClient) => void
) {
  return getLicenceInfoForClientRef().onSnapshot((licencesSnapshot) => {
    if (licencesSnapshot.exists) {
      callback({
        licenceVersion: LicenceVersion.V3,
        licenceDetailsV3: licencesSnapshot.data() as LicenceInfoV3,
      });
    } else {
      return callback({
        licenceVersion: LicenceVersion.V2,
      });
    }
  });
}

export async function getLicenceInfoForClient(): Promise<LicenceInfoOfClient> {
  const licencesSnapshot = await getLicenceInfoForClientRef().get();

  if (licencesSnapshot.exists) {
    return {
      licenceVersion: LicenceVersion.V3,
      licenceDetailsV3: licencesSnapshot.data() as LicenceInfoV3,
    };
  } else {
    return {
      licenceVersion: LicenceVersion.V2,
    };
  }
}

export async function getLicenceInfoOfMemberClients(memberClientIds: string[]) {
  const licencePromises = memberClientIds.map(async (memberClientId) => {
    const licencesSnapshot = await getLicenceInfoForClientRef(memberClientId).get();

    return {
      clientId: memberClientId,
      licenceInfo: licencesSnapshot.exists
        ? {
            licenceVersion: LicenceVersion.V3,
            licenceDetailsV3: licencesSnapshot.data() as LicenceInfoV3,
          }
        : {
            licenceVersion: LicenceVersion.V2,
          },
    };
  });

  // Wait for all requests to complete
  const licenceResults = await Promise.all(licencePromises);

  // Convert array to an object with clientId as key
  return licenceResults;
}
